import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	icon: {
		fill: THEME.colors.primary.contrastText,
	},
});
